import './debounce';
import './scrollbarWidth';
import './scroll-lock';
import './device-detect';
import './real-screen-height';
import { attachPrefetchOnHover, prefetchLinkHref } from './prefetch-link-on-hover';
import { attachScrambleOnHover, scrambleElementText, scrambleLinkText } from './scramble-link-on-hover';

const DESKTOP_MEDIA_QUERY = '(min-width: 1024px)';

function attachGlobalLinkPrefetch() {
    attachPrefetchOnHover(document);
}

function attachGlobalLinkScramble() {
    if (window.matchMedia(DESKTOP_MEDIA_QUERY).matches) {
        attachScrambleOnHover(document, {
            selector: '.header .navigation a[href]:not(.button)',
            lockDimensions: true,
        });
    }

    attachScrambleOnHover(document, {
        selector: '.footer a[href]:not(.button)',
    });
}

function onDOMContentLoaded(callback) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
        callback();
    }
}

if (!document.body.classList.contains('neos-backend')) {
    onDOMContentLoaded(() => {
        attachGlobalLinkPrefetch();
        attachGlobalLinkScramble();
    });
}

export { attachPrefetchOnHover, attachScrambleOnHover, prefetchLinkHref, scrambleElementText, scrambleLinkText };
